import { useEffect, useState } from 'react';
import Button from '../../../../components/button';
import { Modal } from '../../../../components/modal';
import { IBvnResponse, IUserProps } from '../../../../interface/user';
import { useGetUserBvn } from '../../../../services/user';
import { Loading } from '../../../../components/icons';

interface IUserNBvnDetails {
  bvnDetails: IBvnResponse;
}

const ViewBvn = ({ bvnDetails }: IUserNBvnDetails) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className=" w-auto">
        <Button
          onClick={() => {
            setOpen(true);
          }}
          className="!px-3"
        >
          View
        </Button>
      </div>
      <Modal
        isVisible={open}
        close={setOpen}
        center
        padding={false}
        width="medium"
        header
        title="BVN"
      >
        <div>
          <div className="border-b border-gray">
            <div className="flex justify-between py-4 px-4">
              <small>Customer</small>
              <small>{`${bvnDetails?.firstName} ${bvnDetails?.lastName}`}</small>
            </div>
          </div>
          <div className="border-b border-gray">
            <div className="flex justify-between py-4 px-4">
              <small>Identity</small>
              <small>{bvnDetails?.identity}</small>
            </div>
          </div>
          <div className="border-b border-gray">
            <div className="flex justify-between py-4 px-4">
              <small>Gender</small>
              <small>{bvnDetails?.gender}</small>
            </div>
          </div>
          <div className="border-b border-gray">
            <div className="flex justify-between py-4 px-4">
              <small>Email</small>
              <small>{bvnDetails?.email}</small>
            </div>
          </div>
          <div className="border-b border-gray">
            <div className="flex justify-between py-4 px-4">
              <small>Date of birth</small>
              <small>{bvnDetails?.dob}</small>
            </div>
          </div>
          <div className="flex justify-between py-4 px-4">
            <small>Phone</small>
            <small>{bvnDetails?.phone}</small>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewBvn;
